import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../app/shared/shared.module';
import { HeaderComponent } from '../app/header/header.component';
import { LoginComponent } from './login/login.component';
import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { urlInMessageOperator, metaTagsOperator } from '@ngx-share/core';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { ErrorhandlerInterceptorService } from './services/errorhandler-interceptor.service';
import { ToastrModule } from 'ngx-toastr';
import { ForcelogoutComponent } from './forcelogout/forcelogout.component';
import { ForgotPasswordpopupComponent } from './forgot-passwordpopup/forgot-passwordpopup.component';
import { MoveToBankComponent } from './move-to-bank/move-to-bank.component';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NoRightClickDirective } from './no-right-click.directive';

// import { hmrBootstrap } from './hmr';

import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
} from "ngx-ui-loader";
import { RechargeWalletComponent } from './recharge-wallet/recharge-wallet.component';
import { CountdownModule } from 'ngx-countdown';
import { MoveToDistributorComponent } from './move-to-distributor/move-to-distributor.component';
import { DthRechargeComponent } from './dth-recharge/dth-recharge.component';
import { KycComponent } from './kyc/kyc.component';
import { DeviceConfigurationTutorialComponent } from './device-configuration-tutorial/device-configuration-tutorial.component';
import { TdsCertificateComponent } from './tds-certificate/tds-certificate.component';
import { FooterComponent } from './footer/footer.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { RetailerCertificateComponent } from './retailer-certificate/retailer-certificate.component';
import { YesBankEkycComponent } from './yes-bank-ekyc/yes-bank-ekyc.component';
import { UsefullLinksComponent } from './usefull-links/usefull-links.component';
import { MyPlansComponent } from './my-plans/my-plans.component';
import { MediaTypeComponent } from './media-type/media-type.component';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import './icon/icon';
import { ComplaintComponent } from './complaint/complaint.component';
import { ComplaintChatComponent } from './complaint-chat/complaint-chat.component';
import { EarningReportExportComponent } from './earning-report-export/earning-report-export.component';
import { DatePipe } from '@angular/common';
import { PanServiceComponent } from './pan-service/pan-service.component';
import { ComingSoonPopupComponent } from './coming-soon-popup/coming-soon-popup.component';
import { EarningDashboardComponent } from './earning-dashboard/earning-dashboard.component';
import { TwoFactorAuthenticationComponent } from './two-factor-authentication/two-factor-authentication.component';
import { MatmbuyComponent } from './matmbuy/matmbuy.component';
import { CmsComponent } from './cms/cms.component';
import { AirtelcmsComponent } from './airtelcms/airtelcms.component';

/* EasyRin branded loader — green three-strings ring on a blurred void
   overlay, mono-ish caption, thin green progress bar. Colors mirror
   styles/_tokens.scss (config needs literals). */
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsType: "three-strings",
  fgsColor: "#01DC64",
  fgsSize: 64,
  bgsType: "three-strings",
  bgsColor: "#01DC64",
  bgsSize: 40,
  bgsPosition: POSITION.bottomRight,
  overlayColor: "rgba(6, 7, 8, .88)",
  pbColor: "#01DC64",
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 3,
  text: "Working on it…",
  textColor: "#93A09A",
  blur: 6,
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    HomeComponent,
    SideNavComponent,
    ForcelogoutComponent,
    ForgotPasswordpopupComponent,
    MoveToBankComponent,
    RechargeWalletComponent,
    MoveToDistributorComponent,
    DthRechargeComponent,
    NoRightClickDirective,
    KycComponent,
    DeviceConfigurationTutorialComponent,
    TdsCertificateComponent,
    FooterComponent,
    ContactUsComponent,
    NotificationsComponent,
    RetailerCertificateComponent,
    YesBankEkycComponent,
    UsefullLinksComponent,
    MyPlansComponent,
    MediaTypeComponent,
    ComplaintComponent,
    ComplaintChatComponent,
    EarningReportExportComponent,
    PanServiceComponent,
    ComingSoonPopupComponent,
    EarningDashboardComponent,
    TwoFactorAuthenticationComponent,
    MatmbuyComponent,
    CmsComponent,
    AirtelcmsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgbModule,
    BrowserAnimationsModule,
    MatButtonModule,
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    CountdownModule,
    FormsModule,
    ReactiveFormsModule,
    ShareButtonsModule,
    ToastrModule.forRoot({
      timeOut: 25000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }), // ToastrModule added

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [AuthService, AuthGuard,DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorhandlerInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
